<template>
  <div v-if="cdata.length" class="right-top">
    <v-chart :forceFit="true" :height="height" :data="cdata" :padding="padding">
      <v-legend />
      <v-tooltip />
      <v-axis dataKey="item" :label="label2" />
      <v-axis dataKey="percent" :label="label" />
      <v-bar position="item*percent" />
    </v-chart>
  </div>
</template>

<script>
const DataSet = require('@antv/data-set')

export default {
  props: {
    age_group: {
      default() {
        return []
      },
    },
  },
  mounted() {
    const data = this.age_group
		console.log('----2', data)

    const dv = new DataSet.View().source(data)

    const cdata = dv.rows

    const scale = [
      {
        dataKey: 'percent',
        tickInterval: 20,
      },
    ]

    const label = {
      offset: 12,
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const label2 = {
      textStyle: {
        fill: '#82A9EF',
      },
    }
    const adjust = [{ type: 'dodge', marginRatio: 1 / 32 }]
    this.adjust = adjust
    this.scale = scale
    this.label = label
    this.label2 = label2
    this.cdata = cdata
  },
  data() {
    return {
      scale: [],
      cdata: [],
      height: 430 * (window.innerWidth / 1920),
      label: [],
      label2: [],
      adjust: [],
      padding: [
        10 * (window.innerWidth / 1920),
        20 * (window.innerWidth / 1920),
        120 * (window.innerWidth / 1920),
        60 * (window.innerWidth / 1920),
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.right-top {
  padding: 0 15px;
  margin-top: 36px;
}
</style>
